import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { CancelToken } from "axios";
import { Button, message } from "antd";
import MessageClient from "./MessageClient";
import MessageSupport from "./MessageSupport";
import VoiceMessageClient from "./VoiceMessageClient";
import MediaMessageClient from "./MediaMessageClient";
// import ImageMessageClient from "./ImageMessageClient";
import MessageLawyer from "./MessageLawyer";
import VoiceMessageLawyer from "./VoiceMessageLawyer";
import MediaMessageLawyer from "./MediaMessageLawyer";
// import ImageMessageLawyer from "./ImageMessageLawyer";
import {
  MessageStatus,
  MessageType,
  // SessionStatus,
} from "../../../constant/Types";
import { cancelMessage, messageUpdateStatus } from "../../../actions/message";
import HttpService from "../../../constant/Api";
import MessageTicket from "./MessageTicket";
// import MessageCloseTicket from "./MessageCloseTicket";
import MessageRate from "./MessageRate";
import VoiceMessageTicket from "./VoiceMessageTicket";
import { useHistory } from "react-router-dom";
import { getFileService } from "../chat.api";
import { errorMessageHandler } from "../../../constant/helper";
import CallMessage from "./CallMessage";

let waveSurfer = {};

const ChatHolder = ({
  rootType,
  messagesList,
  hasMore = false,
  isTicket = false,
  isTicketClose = false,
  allowRate = false,
  openRateForm,
  chatElement,
  scrollToBottom,
  scrollBtnView,
  totalElements = 0,
  sessionId,
  openLawyerRate,
  sessionDetail,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  function pauseAll(exclude = "") {
    for (const [key, value] of Object.entries(waveSurfer)) {
      if (key !== exclude) value.pause();
    }
  }

  const messageCancel = useCallback(
    (data) => {
      dispatch(cancelMessage(messagesList, data));
    },
    // eslint-disable-next-line
    [messagesList]
  );

  function messageRetry(id) {
    let cancel;
    let cancelToken = new CancelToken((c) => {
      cancel = c;
    });

    dispatch(messageUpdateStatus(id, id, MessageStatus.sending, cancel));
    HttpService.post(
      "/sendMessage2",
      {},
      {
        cancelToken,
        msgId: id,
      }
    )
      .then((resp) => {
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.config &&
          err.response.config.msgId
        ) {
          const msgId = err.response.config.msgId;
          dispatch(messageUpdateStatus(msgId, msgId, MessageStatus.failed));
        }
      });
  }

  const openPdfEditorHandler = async (pdfUrl, fileId) => {
    // debugger;
    setLoading(true);

    if (!pdfUrl) {
      await getFileService(fileId)
        .then((res) => {
          pdfUrl = res.data.url;
        })
        .catch((error) => {
          console.error(error);
          message.error(errorMessageHandler(error));
        });
    }

    sessionStorage.setItem(
      `pdfeditor_${sessionId}_${fileId}`,
      JSON.stringify({
        pdfUrl: encodeURIComponent(pdfUrl),
        backUrl: window.location.pathname,
      })
    );

    setLoading(false);

    history.push(
      `/pdf-editor/${sessionId}/${fileId}/${sessionDetail.sessionStatus}`
    ); // history push
  };

  return (
    <div
      className={"chat-holder"}
      // ref={chatElement}
    >
      {/* {messagesList && totalElements > messagesList.length && (
        <div>
          <Button
            onClick={handleLoadMore}
            block={true}
            type={"primary"}
            shape={"round"}
          >
            بارگذاری پیام های قبلی
          </Button>
        </div>
      )} */}

      {messagesList &&
        messagesList.length > 0 &&
        messagesList.map((i, index) => {
          const key = `message-${i.id}`;
          if (isTicket) {
            switch (i.content) {
              case null:
                return (
                  <VoiceMessageTicket
                    messagesList={messagesList}
                    index={index}
                    currentlyItem={i}
                    key={key}
                    data={{
                      link: i.fileUrl,
                    }}
                    // time={i.time}
                    status={MessageStatus.downloadable}
                    pauseAll={pauseAll}
                    meta={i}
                    messageCancel={messageCancel}
                    messageRetry={messageRetry}
                    waveSurfer={waveSurfer}
                  />
                );
              // case null && i.fileUrl:
              default:
                return (
                  <MessageTicket
                    key={key}
                    data={i}
                    messagesList={messagesList}
                    index={index}
                    currentlyItem={i}
                  />
                );
            }
          }

          switch (i.type) {
            case MessageType.support.rate:
              return (
                <MessageRate
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                  openLawyerRate={openLawyerRate}
                  sessionDetail={sessionDetail}
                />
              );
            case MessageType.client.text:
              return (
                <MessageClient
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                />
              );
            case MessageType.client.voice:
              return (
                <VoiceMessageClient
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  pauseAll={pauseAll}
                  meta={i}
                  messageCancel={messageCancel}
                  messageRetry={messageRetry}
                  waveSurfer={waveSurfer}
                />
              );
            case MessageType.client.media:
              return (
                <MediaMessageClient
                  rootType={rootType}
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                  openPdfEditorHandler={async (pdfUrl, fileId) => {
                    i.status === "ready" &&
                      (await openPdfEditorHandler(pdfUrl, fileId));
                  }}
                  setLoading={setLoading}
                />
              );
            case MessageType.client.image:
              return (
                // <ImageMessageClient
                //   key={key}
                //   data={i.data}
                //   link={i.link}
                //   filename={i.filename}
                //   time={i.time}
                //   status={i.status}
                //   meta={i}
                // />
                <MediaMessageClient
                  setLoading={setLoading}
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                  openPdfEditorHandler={async (pdfUrl, fileId) => {
                    i.status === "ready" &&
                      (await openPdfEditorHandler(pdfUrl, fileId));
                  }}
                />
              );
            case MessageType.support.text:
              return (
                <MessageSupport
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                />
              );
            case MessageType.lawyer.text:
              return (
                <MessageLawyer
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                />
              );
            case MessageType.lawyer.voice:
              return (
                <VoiceMessageLawyer
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  pauseAll={pauseAll}
                  meta={i}
                  messageCancel={messageCancel}
                  messageRetry={messageRetry}
                  waveSurfer={waveSurfer}
                />
              );
            case MessageType.lawyer.image:
              return (
                // <ImageMessageLawyer
                //   key={key}
                //   data={i.data}
                //   link={i.link}
                //   filename={i.filename}
                //   time={i.time}
                //   status={i.status}
                //   meta={i}
                // />
                <MediaMessageLawyer
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                  openPdfEditorHandler={async (pdfUrl, fileId) => {
                    i.status === "ready" &&
                      (await openPdfEditorHandler(pdfUrl, fileId));
                  }}
                />
              );
            case MessageType.lawyer.media:
              return (
                <MediaMessageLawyer
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                  openPdfEditorHandler={async (pdfUrl, fileId) => {
                    i.status === "ready" &&
                      (await openPdfEditorHandler(pdfUrl, fileId));
                  }}
                />
              );
            case MessageType.client.call:
            case MessageType.lawyer.call:
              return (
                <CallMessage
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  pauseAll={pauseAll}
                  meta={i}
                  messageCancel={messageCancel}
                  messageRetry={messageRetry}
                  waveSurfer={waveSurfer}
                />
              );

            default:
              return (
                <MessageSupport
                  messagesList={messagesList}
                  index={index}
                  currentlyItem={i}
                  key={key}
                  data={i.data}
                  time={i.time}
                  status={i.status}
                  meta={i}
                />
              );
            // return <span key={key}> لطفا کمی صبر کنید ...</span>;
          }
        })}

      <div ref={chatElement}></div>
      <Button
        className={`btn-scroll-bottom ${scrollBtnView ? "active" : ""}`}
        type="primary"
        shape="circle"
        onClick={scrollToBottom}
        icon={<span className="icon-arrow-bottom-solid" />}
      />
    </div>
  );
};

export default ChatHolder;
